import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const styles = {
  root: {
    marginTop: '0.5em',
    marginBottom: '0.5em'
  },
  label: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '0.9285714285714286rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  },
  body: {
    color: 'rgba(0, 0, 0, 0.87)',
    // paddingTop: '1em',
    // paddingBottom: '1em',
    fontSize: '0.9285714285714286rem',
    fontWeight: 400,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
  }
};

const CustomTextField = ({ title, value, component }) => {
  return (
    <div style={styles.root}>
      <Typography variant="caption" style={styles.label}>
        {title}
      </Typography>
      <Typography style={styles.body} component={component}>
        {value}
      </Typography>
    </div>
  );
}

CustomTextField.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([
  PropTypes.string,
	PropTypes.node,
	]),
  component: PropTypes.string,
};

CustomTextField.defaultProps = {
  value: '',
  title: '',
  component: 'div',
};

export default CustomTextField;
